<template>
    <div class="flex flex-col pt-9 pb-52 bg-white min-h-[1600px]">
      <BreadCrumb text="主页/荣誉展示"></BreadCrumb>
      <SectionBar text="荣誉展示"></SectionBar>
      <div
        class="self-center mt-16 w-full max-w-[1394px] max-md:mt-10 max-md:max-w-full"
      >
        <div class="flex gap-5 max-md:flex-col">
          <div class="flex flex-col w-6/12 max-md:ml-0 max-md:w-full">
            <div
              class="flex flex-col grow px-20 py-16 w-full text-5xl font-semibold text-black whitespace-nowrap rounded-lg bg-zinc-100 max-md:px-5 max-md:mt-10 max-md:max-w-full"
            >
              <img
                loading="lazy"
                srcSet="/images/certification/cer11.png"
                class="mt-11 ml-4 max-w-full aspect-[1.39] w-[433px] max-md:mt-10"
              />
              <div class="self-center mt-20 max-md:mt-10">国家高新企业证书</div>
            </div>
          </div>
          <div class="flex flex-col ml-5 w-6/12 max-md:ml-0 max-md:w-full">
            <div
              class="flex grow justify-center items-center px-16 py-16 w-full text-5xl font-semibold text-black whitespace-nowrap rounded-lg bg-zinc-100 max-md:px-5 max-md:mt-10 max-md:max-w-full"
            >
              <div class="flex flex-col mt-9 max-w-full w-[433px]">
                <img
                  loading="lazy"
                  srcSet="/images/certification/cer12.png"
                  class="w-full aspect-[1.39] max-md:max-w-full"
                />
                <div class="self-center mt-24 max-md:mt-10">高新技术企业证书</div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div
        class="self-center mt-20 w-full max-w-[1395px] max-md:mt-10 max-md:max-w-full"
      >
        <div class="flex gap-5 max-md:flex-col">
          <div class="flex flex-col w-6/12 max-md:ml-0 max-md:w-full">
            <div
              class="flex flex-col grow px-14 py-8 w-full text-5xl font-semibold text-black whitespace-nowrap rounded-lg bg-zinc-100 max-md:px-5 max-md:mt-10 max-md:max-w-full"
            >
              <img
                loading="lazy"
                srcSet="/images/certification/cer21.png"
                class="self-center max-w-full aspect-[0.7] w-[335px]"
              />
              <div class="mt-8 max-md:max-w-full">集成电路分布图设计登记证书</div>
            </div>
          </div>
          <div class="flex flex-col ml-5 w-6/12 max-md:ml-0 max-md:w-full">
            <div
              class="flex grow justify-center items-center px-16 py-8 w-full text-5xl font-semibold text-center text-black whitespace-nowrap rounded-lg bg-zinc-100 max-md:px-5 max-md:mt-10 max-md:max-w-full"
            >
              <div class="flex flex-col max-w-full w-[335px]">
                <img
                  loading="lazy"
                  srcSet="/images/certification/cer22.png"
                  class="w-full aspect-[0.7]"
                />
                <div class="self-center mt-7">质量优胜奖</div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div
        class="self-center mt-20 w-full max-w-[1398px] max-md:mt-10 max-md:max-w-full"
      >
        <div class="flex gap-5 max-md:flex-col">
          <div class="flex flex-col w-6/12 max-md:ml-0 max-md:w-full">
            <div
              class="flex flex-col grow px-12 pt-20 pb-9 w-full text-5xl font-semibold text-black whitespace-nowrap rounded-lg bg-zinc-100 max-md:px-5 max-md:mt-10 max-md:max-w-full"
            >
              <img
                loading="lazy"
                srcSet="/images/certification/cer31.png"
                class="w-full aspect-[1.39] max-md:max-w-full"
              />
              <div class="mt-16 max-md:mt-10 max-md:max-w-full">
                集成电路分布图设计登记证书
              </div>
            </div>
          </div>
          <div class="flex flex-col ml-5 w-6/12 max-md:ml-0 max-md:w-full">
            <div
              class="flex grow justify-center items-center px-16 py-10 w-full text-5xl font-semibold text-center text-black whitespace-nowrap rounded-lg bg-zinc-100 max-md:px-5 max-md:mt-10 max-md:max-w-full"
            >
              <div class="flex flex-col max-w-full w-[426px]">
                <img
                  loading="lazy"
                  srcSet="/images/certification/cer32.png"
                  class="self-center max-w-full aspect-[0.7] w-[323px]"
                />
                <div class="mt-7 max-md:max-w-full">质量管理体系认证证书</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </template>

<script>
import SectionBar from '@/components/SectionBar.vue';
import BreadCrumb from '@/components/BreadCrumb.vue';
export default {
  name: 'HonorPage',
  components:{
    SectionBar,
    BreadCrumb,
  }

};
</script>